import { UserLayoutGridMetaData } from '../../layout-meta-data/user-layout-grid-meta-data';
import { Expose, Type } from '@nts/std/serialization';
import { BaseLayoutDataDto } from './base-layout-data.dto';
import type { GridUserLayoutDataDtoInterface, UserLayoutGridMetaDataInterface } from '@nts/std/interfaces';

export class GridUserLayoutDataDto extends BaseLayoutDataDto implements GridUserLayoutDataDtoInterface {

    constructor() {
        super();
        this.gridMetaData = new UserLayoutGridMetaData();
    }

    @Expose()
    @Type(() => UserLayoutGridMetaData)
    gridMetaData: UserLayoutGridMetaDataInterface;
}
